// type
import { EasyyTheme } from "../../../../theme"

export function lineHeightResolver(value: unknown, theme: EasyyTheme) {
  if (typeof value === "string" && value in theme.lineHeights) {
    return theme.lineHeights[value as keyof typeof theme.lineHeights]
  }
  return value
}
